export default function ModularSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Texto */}
          <div>
            <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
              Carpete modular
            </p>
            <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight mb-6">
              Carpete em placas para projetos corporativos.
            </h2>

            <div className="space-y-4 text-foreground-500 text-[15px] md:text-[16px] leading-relaxed">
              <p>
                O carpete modular permite criar paginações, combinações e diferentes composições de
                ambiente. É uma alternativa pensada para espaços que precisam unir desempenho,
                estética e praticidade no dia a dia.
              </p>
              <p>
                Dependendo da linha escolhida, facilita intervenções localizadas e substituição de
                módulos — o que pode reduzir o impacto de manutenções pontuais sem comprometer o
                conjunto do piso corporativo.
              </p>
            </div>
          </div>

          {/* Imagens */}
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[3/4]">
              <img
                src="/media/ia/0475.webp"
                alt="Carpete em placas com textura em ambiente corporativo"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[3/4] mt-8">
              <img
                src="/media/ia/0476.webp"
                alt="Sala de reunião corporativa com carpete modular"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}